export const SELECT_STATUS_INIT = 'SELECT_STATUS_INIT'
export const SELECT_STATUS_SET_VALUE = 'SELECT_STATUS_SET_VALUE'
